import { render, staticRenderFns } from "./EventEditView.vue?vue&type=template&id=b205a984&"
import script from "./EventEditView.vue?vue&type=script&lang=js&"
export * from "./EventEditView.vue?vue&type=script&lang=js&"
import style0 from "./EventEditView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports